module.exports = __webpack_public_path__ + "static/media/lucario_0.7aef3bfa.png";